import axios from 'axios';

const url = process.env.VUE_APP_HOST;

const getResourceType = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/Resource/ResourceType';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const getResourceByType = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/Resource/ResourceType/'+id+'/Resource';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const getRelationByResource = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/Resource/ResourceRelation/'+id;

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const postRelationByResource = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Resource/ResourceRelation/'+payload.ParentResourceIdentity;

    let result = await axios.post(urlWithArg, payload, headers);
    
    return result.data;

}

const putRelationByResource = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/Resource/ResourceRelation/'+payload.ParentResourceIdentity;

    let result = await axios.put(urlWithArg, payload, headers);
    
    return result.data;

}


export const resourceTypeService = { getResourceType, getResourceByType, getRelationByResource, postRelationByResource, putRelationByResource }


// WEBPACK FOOTER //
// ./src/api/resource-type.service.js